import { getQueryParams } from '@/infrastructure/Utils'
import { DateFactory } from 'rhg-vue-common'
import SearchTypes from '@/domain/SearchTypes'

export function buildSearchAnalytics() {
  const URL_QUERY_PARAMS = window.location._search || window.location.search

  let analyticsSearch = {}

  if (!previousPageWasSearchResults()) {
    const { checkInDate, checkOutDate, adults, children, searchType, promotionCode } =
      getQueryParams(URL_QUERY_PARAMS)

    if (!checkInDate || !checkOutDate) {
      return
    }

    const adultCount = adultsCount(adults)
    const childCount = childrenCount(children)

    analyticsSearch = {
      searchArrivalDate: formatAnalyticsDate(checkInDate),
      searchDepartureDate: formatAnalyticsDate(checkOutDate),
      searchRoomCount: numberOfRooms(adults),
      searchAdultCount: adultCount,
      searchChildCount: String(childCount),
      searchGuestCount: adultCount + childCount,
      searchDaysInAdvance: String(daysInAdvance(checkInDate)),
      searchReservationDuration: numberOfNights(checkInDate, checkOutDate),
      searchRoomOccupancy: roomOccupancy(adults, children)
    }

    analyticsSearch = appendData(analyticsSearch, getSessionStorageFirstSearchCompleted())
    analyticsSearch = appendData(
      analyticsSearch,
      getSearchTypeAndPromotionCode('search', searchType, promotionCode)
    )
    analyticsSearch = appendData(
      analyticsSearch,
      global.CookieAnalytics.getJson(global.cookieTypes.SEARCH_BAR_ANALYTICS)
    )
  }

  global.SessionStorage.set(global.sessionStorageDictionary.firstSearchCompleted, true)

  return analyticsSearch
}

export function buildBookingAnalytics() {
  const URL_QUERY_PARAMS = window.location._search || window.location.search

  const { checkInDate, checkOutDate, adults, children, aoc, searchType, promotionCode } =
    getQueryParams(URL_QUERY_PARAMS)

  if (!checkInDate || !checkOutDate) {
    return
  }

  let analyticsBooking = {
    bookingCheckInDate: formatAnalyticsDate(checkInDate),
    bookingCheckOutDate: formatAnalyticsDate(checkOutDate),
    bookingNumberOfRooms: numberOfRooms(adults),
    bookingTotalAdults: adults && adults.join('|'),
    bookingTotalChildren: childrenCount(children) === 0 ? '0' : children.join('|'),
    bookingChildrenAge: aoc?.length > 0 ? aoc.join('|') : undefined,
    bookingTotalAdultTotalChildrenPerRoom: totalAdultsTotalChildrenPerRoom(adults, children),
    bookingTotalGuests: adultsCount(adults) + childrenCount(children),
    bookingRoomNights: totalNumberOfRooms(adults, checkInDate, checkOutDate),
    bookingDaysInAdvance: daysInAdvance(checkInDate)
  }
  analyticsBooking = appendData(
    analyticsBooking,
    getSearchTypeAndPromotionCode('booking', searchType, promotionCode)
  )

  return appendData(
    analyticsBooking,
    global.CookieAnalytics.getJson(global.cookieTypes.BOOKING_CONFIRMATION_ANALYTICS)
  )
}

export function appendData(dataTarget, dataSource) {
  if (dataTarget && dataSource) {
    return Object.assign(dataTarget, dataSource)
  }
  return dataTarget
}

function previousPageWasSearchResults() {
  const referrer = document.referrer
  return referrer && referrer.includes('search-results')
}

function adultsCount(adults) {
  if (adults) {
    return adults.reduce(function (total, current) {
      return total + parseInt(current)
    }, 0)
  }
  return 1
}

function childrenCount(children) {
  if (children) {
    return children.reduce(function (total, current) {
      return total + parseInt(current)
    }, 0)
  }
  return 0
}

function totalNumberOfRooms(adults, checkInDate, checkOutDate) {
  var totalRooms = numberOfRooms(adults)
  var totalNights = numberOfNights(checkInDate, checkOutDate)
  if (totalNights && totalRooms) {
    return totalNights * totalRooms
  } else {
    return totalNights
  }
}

function numberOfRooms(adults) {
  return adults ? adults.length : 1
}

function daysInAdvance(date) {
  if (date) {
    return DateFactory.daysBetween(DateFactory.today(), date)
  }
  return null
}

function numberOfNights(startDate, endDate) {
  if (startDate && endDate) {
    return DateFactory.daysBetween(startDate, endDate)
  }
  return null
}

function roomOccupancy(adults, children) {
  if (adults && children) {
    var rooms = []
    var min = Math.min(adults.length, children.length)
    for (var i = 0; i < min; i++) {
      rooms.push(i + 1 + ':' + adults[i] + ':' + children[i])
    }
    return rooms.join('|')
  }
}

function totalAdultsTotalChildrenPerRoom(adults, children) {
  if (adults && children) {
    var rooms = []
    var min = Math.min(adults.length, children.length)
    for (var i = 0; i < min; i++) {
      rooms.push(adults[i] + ',' + children[i])
    }
    return rooms.join('|')
  }
}

function getSessionStorageFirstSearchCompleted() {
  const analytics = {
    isModifiedSearch: false
  }
  const isModifiedSearch = global.SessionStorage.get(
    global.sessionStorageDictionary.firstSearchCompleted
  )
  if (isModifiedSearch) {
    analytics.isModifiedSearch = isModifiedSearch
  }
  return analytics
}

function getSearchTypeAndPromotionCode(prefix, searchType, promotionCode) {
  const analyticsTypeSearch = {}
  if (searchType && promotionCode) {
    var varName
    if (searchType === SearchTypes.TRAVEL_AGENCY) {
      varName = 'TravelAgencyId'
    } else if (searchType === SearchTypes.CORPORATE_ACCOUNT) {
      varName = 'CorporateId'
    } else if (searchType === SearchTypes.PAC) {
      varName = 'PromoCode'
    } else if (searchType === SearchTypes.ECERT) {
      varName = 'EcertCode'
    }
    analyticsTypeSearch[prefix + varName] = promotionCode
  }
  return analyticsTypeSearch
}

function formatAnalyticsDate(date) {
  if (date) {
    return DateFactory.formatDate(date, DateFactory.DatePatterns.ANALYTICS)
  }
  return null
}
